import moment from 'moment';
import React from "react";
import { Popover } from "antd";
import { useSelector } from 'react-redux';

const universalSorter = (valueA, valueB, profile) => {
    const extractText = (val) => {
        if (React.isValidElement(val)) {
            val = val.props?.children ?? '';
        }
        if (Array.isArray(val)) {
            val = val.map(child => {
                if (React.isValidElement(child)) {
                    return child.props?.children ?? '';
                }
                return child;
            }).join(' ');
        }
        if (typeof val === 'number') return val;
        if (typeof val === 'string') {
            const trimmed = val.trim();
            if (profile?.dateFormate && moment(trimmed, profile.dateFormate, true).isValid()) {
                return moment(trimmed, profile.dateFormate, true).toDate().getTime();
            }
            const cleaned = trimmed
                .replace(/^[^\d-]+/, '')
                .replace(/,/g, '')
                .replace(/\s+/g, '');
            const numberMatch = cleaned.match(/^(\d+(\.\d+)?)/);
            if (numberMatch) {
                return parseFloat(numberMatch[0]);
            }
            return trimmed.toLowerCase();
        }
        return '';
    };
    const a = extractText(valueA);
    const b = extractText(valueB);
    if (typeof a === 'number' && typeof b === 'number') {
        return a - b;
    }
    return String(a).localeCompare(String(b), undefined, { numeric: true });
};
export const generateDynamicColumns = (checkboxValues, ViewDetailPage, sortedInfo) => {
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    let columns = [];
    if (checkboxValues !== undefined) {
        columns = checkboxValues
            .filter((item) => item.isChecked)
            .map((item) => {
                const columnConfig = {
                    title: item.name,
                    dataIndex: item.FieldValue,
                    key: item.FieldValue,
                    sortDirections: ['ascend', 'descend'],
                    sortOrder: sortedInfo?.column?.dataIndex === item.FieldValue ? sortedInfo?.order : null
                };
                switch (item.FieldValue) {
                    case 'relatedto':
                        columnConfig.onCell = () => ({
                            onClick: (e) => {
                                e.stopPropagation();
                            },
                        });
                        break;
                    case 'entityName':
                        columnConfig.onCell = () => ({
                            onClick: (e) => {
                                e.stopPropagation();
                            },
                        });
                        // columnConfig.sorter = (a, b) => {
                        //     const extractText = (element) => {
                        //         return element && element.props && element.props.children !== undefined
                        //             ? String(element.props.children)
                        //             : '';
                        //     };
                        //     const relatedtoA = extractText(a[item.FieldValue]);
                        //     const relatedtoB = extractText(b[item.FieldValue]);
                        //     return relatedtoA.localeCompare(relatedtoB);
                        // };
                        // columnConfig.render = (relatedToArray) => (
                        //     <span>
                        //         {Array.isArray(relatedToArray.props.children) ? (
                        //             relatedToArray.props.children.map((item, index) => (
                        //                 <span key={index}>
                        //                     {item}
                        //                     {index !== relatedToArray.props.children.length - 1 && ', '}
                        //                 </span>
                        //             ))
                        //         ) : (
                        //             relatedToArray.props.children
                        //         )}
                        //     </span>
                        // );
                        break;
                    case 'assignTo':
                        columnConfig.onCell = (record) => ({
                            onClick: (e) => {
                                e.stopPropagation();
                                if (Role === "Administrator" || profile.userId === record.ASuseriId) {
                                    ViewDetailPage(record.ASuseriId, "USER")
                                }
                            },
                        });
                        columnConfig.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.assignTo.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children[0].props.children.trim() : ''; // Extract first div inside figcaption
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    case 'taskOwner':
                        columnConfig.onCell = (record) => ({
                            onClick: (e) => {
                                e.stopPropagation();
                                if (Role === "Administrator" || profile.userId === record.userId) {
                                    ViewDetailPage(record.userId, "USER")
                                }
                            },
                        });
                        columnConfig.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.taskOwner.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children[0].props.children.trim() : ''; // Extract first div inside figcaption
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    case 'taskname':
                        columnConfig.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.taskname.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children[0].props.children.trim() : ''; // Extract first div inside figcaption
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    default:
                        columnConfig.sorter = (a, b) => {
                            const valueA = a[item.FieldValue]?.props?.children || '';
                            const valueB = b[item.FieldValue]?.props?.children || '';
                            return universalSorter(valueA, valueB, profile);
                        };
                        break;
                }
                return columnConfig;
            });
    }
    return columns;
};

export const generateUsersTableData = (exportData, ViewDetailPage) => {
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const usersTableData = [];
    if (exportData) {
        exportData.forEach((task, key) => {
            usersTableData.push({
                taskData: task,
                ASuseriId: task.assign_to,
                userId: task.task_owner,
                key: task.task_id,
                no: key + 1,
                taskname: (<div className="user-info_image table_list_clicks">
                    {task.task_profile !== null && task.task_profile !== undefined && task.task_profile !== "" ?
                        < figure >
                            <img style={{ width: "30px", height: "30px" }} src={task.task_profile} alt="" />
                        </figure>
                        :
                        <span className='list_span_Tag TaskIcon'>
                            {task.task_name && task.task_name.slice(0, 1).toUpperCase()}
                        </span>
                    }
                    <figcaption>
                        <div>
                            {task.task_name}
                        </div>
                        <div className='entityemail'>
                            {task.task_status_name}
                        </div>
                    </figcaption>
                </div >),
                taskOwner: (<div className={`user-info_image ${(Role === "Administrator" || profile.userId === task.task_owner) && "ListNavigate"}`}>
                    {task.userProfilePic !== null && task.userProfilePic !== undefined && task.userProfilePic !== "" ?
                        < figure >
                            <img style={{ width: "30px", height: "30px" }} src={task.userProfilePic} alt="" />
                        </figure>
                        :
                        <span className='list_span_Tag UserIcon'>
                            {task.userFirstName && task.userFirstName.slice(0, 1).toUpperCase()}
                        </span>
                    }
                    <figcaption>
                        <div>
                            {`${task.userFirstName} ${task.userLastName}`}
                        </div>
                        <div className='entityemail'>
                            {task.taskOwner}
                        </div>
                    </figcaption>
                </div>),
                assignTo: (<div className={`user-info_image ${(Role === "Administrator" || profile.userId === task.assign_to) && "ListNavigate"}`}>
                    {task.assigneeProfilePic !== null && task.assigneeProfilePic !== undefined && task.assigneeProfilePic !== "" ?
                        < figure >
                            <img style={{ width: "30px", height: "30px" }} src={task.assigneeProfilePic} alt="" />
                        </figure>
                        :
                        <span className='list_span_Tag UserIcon'>
                            {task.assigneeFirstName && task.assigneeFirstName.slice(0, 1).toUpperCase()}
                        </span>
                    }
                    <figcaption>
                        <div>
                            {`${task.assigneeFirstName} ${task.assigneeLastName}`}
                        </div>
                        <div className='entityemail'>
                            {task.assignTo}
                        </div>
                    </figcaption>
                </div>),
                entityName: (<div className='table_list_clicks'
                    style={{ display: "flex", alignItems: "center", gap: "5px", flexWrap: "nowrap" }}>
                    <div>{task.task_type_name}</div>
                    {task.task_type_name !== "Personal" ?
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: "nowrap", // Keeps all items in a row
                            minWidth: "max-content", // Ensures it grows as needed
                        }}>
                            {task.relatedToDetail && task.relatedToDetail.length > 0 &&
                                (<>
                                    {task.relatedToDetail.slice(0, 3).map((item, index) => {
                                        let permission;
                                        if (task.task_type_name === "Account") { permission = item.entityPermission }
                                        if (task.task_type_name === "Lead") { permission = item.entityPermission }
                                        if (task.task_type_name === "Deal") { permission = item.entityPermission }
                                        if (task.task_type_name === "Contact") { permission = item.entityPermission }
                                        if (task.task_type_name === "Case") { permission = item.entityPermission }
                                        return (
                                            <div title={item.name} key={index} role="button"
                                                tabIndex={0}
                                                style={{ cursor: !permission && "not-allowed" }}
                                                onKeyDown={(event) => {
                                                    if (permission && (event.key === 'Enter' || event.key === ' ')) {
                                                        ViewDetailPage(item.id,
                                                            task.task_type_name === "Account" ? "ACCOUNT"
                                                                : task.task_type_name === "Lead" ? "LEAD" :
                                                                    task.task_type_name === "Deal" ? "DEAL" :
                                                                        task.task_type_name === "Contact" ? "CONTACT" :
                                                                            task.task_type_name === "Case" ? `?${item.entityPermissionType}` : "")
                                                    }
                                                }}
                                                onClick={permission ? () => ViewDetailPage(item.id, task.task_type_name === "Account" ? "ACCOUNT"
                                                    : task.task_type_name === "Lead" ? "LEAD" :
                                                        task.task_type_name === "Deal" ? "DEAL" :
                                                            task.task_type_name === "Contact" ? "CONTACT" :
                                                                task.task_type_name === "Case" ? `?${item.entityPermissionType}` : ""
                                                ) : undefined}>
                                                {item.profilePic !== null && item.profilePic !== undefined && item.profilePic !== "" ?
                                                    <span className="image_icon OverLap_images">
                                                        <img style={{
                                                            width: '30px',
                                                            height: '30px',
                                                            borderRadius: '50%',
                                                        }}
                                                            src={item.profilePic} alt="" />
                                                    </span>
                                                    :
                                                    <span
                                                        className={`image_icon OverLap_images ${task.task_type_name === "Account" ? "AccountIcon"
                                                            : task.task_type_name === "Lead" ? "LeadIcon" :
                                                                task.task_type_name === "Deal" ? "DealIcon" :
                                                                    task.task_type_name === "Contact" && "ContactIcon"}`}
                                                    >
                                                        {item?.name?.slice(0, 1).toUpperCase()}
                                                    </span >
                                                }
                                            </div>
                                        )
                                    })}
                                    {task.relatedToDetail.length > 3 && (
                                        <Popover
                                            placement="bottomLeft"
                                            trigger="hover"
                                            content={
                                                <div
                                                    style={{
                                                        maxHeight: "200px",
                                                        overflowY: "auto",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: "8px",
                                                        padding: "4px 0",
                                                    }}
                                                >
                                                    {task.relatedToDetail.slice(3).map((item, index) => {
                                                        let permission;
                                                        if (task.task_type_name === "Account") { permission = item.entityPermission }
                                                        if (task.task_type_name === "Lead") { permission = item.entityPermission }
                                                        if (task.task_type_name === "Deal") { permission = item.entityPermission }
                                                        if (task.task_type_name === "Contact") { permission = item.entityPermission }
                                                        if (task.task_type_name === "Case") { permission = item.entityPermission }
                                                        return (<div title={item.name} key={index} role="button"
                                                            tabIndex={0}
                                                            style={{ cursor: permission ? "pointer" : "not-allowed", display: "flex", alignItems: "center", gap: "8px", marginBottom: 10 }}
                                                            onKeyDown={(event) => {
                                                                if (permission && (event.key === 'Enter' || event.key === ' ')) {
                                                                    ViewDetailPage(item.id,
                                                                        task.task_type_name === "Account" ? "ACCOUNT"
                                                                            : task.task_type_name === "Lead" ? "LEAD" :
                                                                                task.task_type_name === "Deal" ? "DEAL" :
                                                                                    task.task_type_name === "Contact" ? "CONTACT" :
                                                                                        task.task_type_name === "Case" ? `?${item.entityPermissionType}` : "")
                                                                }
                                                            }}
                                                            onClick={permission ? () => ViewDetailPage(item.id, task.task_type_name === "Account" ? "ACCOUNT"
                                                                : task.task_type_name === "Lead" ? "LEAD" :
                                                                    task.task_type_name === "Deal" ? "DEAL" :
                                                                        task.task_type_name === "Contact" ? "CONTACT" :
                                                                            task.task_type_name === "Case" ? `?${item.entityPermissionType}` : ""
                                                            ) : undefined}>
                                                            {item.profilePic !== null && item.profilePic !== undefined && item.profilePic !== "" ? (
                                                                <img
                                                                    src={item?.profilePic}
                                                                    alt={item?.name}
                                                                    style={{
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        borderRadius: '50%',
                                                                    }}
                                                                />
                                                            ) : (
                                                                <span className={`image_icon ${task.task_type_name === "Account" ? "AccountIcon"
                                                                    : task.task_type_name === "Lead" ? "LeadIcon" :
                                                                        task.task_type_name === "Deal" ? "DealIcon" :
                                                                            task.task_type_name === "Contact" && "ContactIcon"}`}>
                                                                    {item?.name?.slice(0, 1)?.toUpperCase()}
                                                                </span>
                                                            )}
                                                            <span>{item?.name}</span>
                                                        </div>
                                                        )
                                                    })}
                                                </div>
                                            }
                                        >
                                            <span
                                                style={{
                                                    marginLeft: "25px",
                                                    fontSize: "13px",
                                                    fontWeight: 500,
                                                    color: "#1677ff",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                +{task.relatedToDetail.length - 3} more
                                            </span>
                                        </Popover>
                                    )}
                                </>
                                )}
                        </div > : <></>
                    }
                </div>),
                taskStatus: (<div className={`table_list_clicks status-text Task${task.task_status_id}`}>{task.task_status_name}</div>),
                priority: (<div className={`table_list_clicks status-text Task${task.priority}`}>{task.priority}</div>),
                description: (<div className='table_list_clicks'>{task.description ? `${task.description.substring(0, 50)}...` : task.description}</div>),
                dueDate: (<div className='table_list_clicks'>
                    {task?.due_date}
                </div>),
                createdat: (<div className='table_list_clicks'>
                    {task?.created_at}
                </div>),
                modifiedat: (<div className='table_list_clicks'>
                    {task?.modified_at}
                </div>),
            });
        });
    }
    return usersTableData;
};

